<script>
export default {
  name: "app",
  data() {
    return {
      imageSize: "150px",
      links: [
        {
          title: "LinkedIn",
          url: "https://www.linkedin.com/in/ryanrskeldon/",
          icon: "mdi-linkedin",
        },
        {
          title: "GitHub",
          url: "https://github.com/psykad/",
          icon: "mdi-github",
        },
      ],
      description:
        "Self-taught developer with 10+ years of experience developing full-stack systems for the manufacturing environment.",
    };
  },
};
</script>

<template>
  <v-app
    :style="{ background: $vuetify.theme.themes['dark'].background, color: $vuetify.theme.themes['dark'].fontColor }"
  >
    <v-main>
      <v-container fluid>
        <v-row justify="center">
          <v-col sm="3">
            <v-card v-if="!$vuetify.breakpoint.xs">
              <v-card-title>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-img src="./assets/avatar-recolored.svg"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Ryan Skeldon</v-list-item-title>
                    <v-list-item-subtitle>Software Developer</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card-title>
              <v-card-text>
                <p>{{description}}</p>
              </v-card-text>
              <v-card-actions>
                <v-btn icon class="ma-2" v-for="(item, i) in links" :key="i" :href="item.url">
                  <v-icon color="primary">{{item.icon}}</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-sheet v-else elevation="2" rounded>
              <v-row>
                <v-col>
                  <v-layout class="justify-center">
                    <v-img src="./assets/avatar-recolored.svg" :max-width="imageSize"></v-img>
                  </v-layout>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center">
                  <div class="text-h4">Ryan Skeldon</div>
                  <div class="text-subtitle-2">Software Developer</div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center">
                  <p class="pa-5 text-body-1">{{description}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center">
                  <v-btn x-large icon class="ma-2" v-for="(item, i) in links" :key="i" :href="item.url">
                    <v-icon x-large color="primary">{{item.icon}}</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>